import React from 'react';
import { Commission } from '../types/commission';
import { CommissionCard } from './CommissionCard';
import { motion } from 'framer-motion';
interface CommissionGridProps {
  data: Commission[];
  isLoading?: boolean;
}
export function CommissionGrid({
  data,
  isLoading
}: CommissionGridProps) {
  if (isLoading) {
    return <div className="w-full h-64 flex items-center justify-center text-slate-400" data-id="element-86">
        Loading commission data...
      </div>;
  }
  if (data.length === 0) {
    return <div className="w-full h-64 flex flex-col items-center justify-center text-slate-400 bg-white rounded-xl border border-slate-200 border-dashed" data-id="element-87">
        <p className="text-lg font-medium text-slate-600" data-id="element-88">
          No commissions found
        </p>
        <p className="text-sm mt-1" data-id="element-89">
          Try adjusting your filters or search query.
        </p>
      </div>;
  }
  return <motion.div layout className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-id="element-90">
      {data.map(commission => <CommissionCard key={commission.userId} commission={commission} data-id="element-91" />)}
    </motion.div>;
}